"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.LoadingModal = void 0;

var _react = _interopRequireDefault(require("react"));

var _CheckMark = _interopRequireDefault(require("./CheckMark"));

var _loader = _interopRequireDefault(require("../loader"));

var _WarningSign = _interopRequireDefault(require("./WarningSign"));

var _Modal = _interopRequireDefault(require("@material-ui/core/Modal"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var styles = function styles(theme) {
  return {
    root: {
      backgroundColor: theme.palette.primary.main,
      boxShadow: theme.shadows[5],
      color: theme.palette.common.white,
      margin: 'auto',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      padding: theme.spacing(1)
    }
  };
};

var LoadingModal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(LoadingModal, _React$Component);

  function LoadingModal(props) {
    var _this;

    _classCallCheck(this, LoadingModal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LoadingModal).call(this, props));
    _this.state = {
      error: false,
      open: true,
      resolved: false
    };
    return _this;
  }

  _createClass(LoadingModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.props.promise().then(function () {
        _this2.setState(function () {
          return {
            resolved: true
          };
        });
      })["catch"](function (error) {
        _this2.setState(function () {
          return {
            error: true,
            errorLabel: error.message
          };
        });
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.callback();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          closeModal = _this$props.closeModal,
          successLabel = _this$props.successLabel;
      var _this$state = this.state,
          error = _this$state.error,
          errorLabel = _this$state.errorLabel,
          open = _this$state.open,
          resolved = _this$state.resolved;
      return _react["default"].createElement(_Modal["default"], {
        "aria-labelledby": "Cargando",
        "aria-describedby": "Cargando",
        open: open
      }, _react["default"].createElement("div", {
        className: classes.root
      }, resolved ? _react["default"].createElement(_CheckMark["default"], {
        callback: closeModal,
        label: successLabel
      }) : error ? _react["default"].createElement(_WarningSign["default"], {
        callback: closeModal,
        label: errorLabel
      }) : _react["default"].createElement(_loader["default"], null)));
    }
  }]);

  return LoadingModal;
}(_react["default"].Component);

exports.LoadingModal = LoadingModal;

var _default = (0, _styles.withStyles)(styles)(LoadingModal);

exports["default"] = _default;